module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"autoApply":"Auto Apply at Checkout","copied":"Copied!"},"lng_zh":{"autoApply":"結賬時自動申請","copied":"已复制!"},"lng_th":{"autoApply":"ใช้คูปองอัตโนมัติเมื่อชำระเงิน","copied":"คัดลอก!"},"lng_id":{"autoApply":"Terapkan Otomatis saat Checkout","copied":"Disalin!"},"lng_ko":{"autoApply":"결제 시 자동 적용","copied":"복사되었습니다!"}}')
  delete Component.options._Ctor
}
